import update from "immutability-helper";
import {isSet,layoutRulesValidation,checkIsStatusFieldIsExists,checkIsAvatarIsExists,setLookupMappingFieldValue, getHardCodedIds} from "../../Utils/CommonFunctions";
import {updateUsedAndUnusedFields,isUsedFieldsLimitReached} from '../../Containers/LayoutContainer/LayoutCommonFunction';
import {
  LAYOUT_SETTINGS,
  LAYOUT_FIELD_COUNT,
  ADD_ITEM_TO_PREVIEW,
  REMOVE_ITEM_FROM_PREVIEW,
  DRAG_ITEM_IN_PREVIEW,
  SHOW_EDITOR,
  HIDE_EDITOR,
  SUBMIT_EDITOR_STATE,
  ADD_SECTION_TO_PREVIEW,
  ADD_FORM_TO_PREVIEW,
  SET_LAYOUT_DATA,  
  DRAG_CONTENT_IN_PREVIEW,
  ADD_COPY_SECTION_TO_LAYOUT,
  UPDATE_SECTION_HEAD,
  REMOVE_SECTION,
  LAYOUT_COLUMN_CHANGE,
  UPDATE_LAYOUT_ONCHANGE,
  ADD_REMOVE_ITEM_TO_QUICK_CREATE,
  HANDLE_INPUT_CHANGE,
  UPDATE_FORM_FIELD_VALIDATION,
  CLEAR_FORM_FIELD_VALIDATION,
  ADD_SELECTED_MULTILOOKUP,
  REMOVE_SELECTED_MULTILOOKUP,
  CLEAR_SELECTED_MULTILOOKUP,
  SET_SELECTED_MULTILOOKUP,
  DROPDOWN_FIELD_MAPPING,
  DETAILVIEW_ADD,
  DETAILVIEW_TYPE_HANDLER,
  SET_VALIDATION_RULES,
  SET_LAYOUT_RULES,
  FIELD_PERMISSION_ONCHANGE,
  MASTER_WINDOW_LIST_ACTION,
  UPDATE_ACTION_BUTTON,
  SET_SUBFORM_DATA,
  UPDATE_SUBFORM_DATA,
  SET_LOOKUP_DEPENDENCY,
  UPDATE_DETAIL_VIEW_STATUS,
  UPDATE_SUBFORM_FIELD_VALIDATION,
  ADD_REMOVE_ITEM_TO_MOBILE_VIEW,
  SET_LAYOUT_DATA_SUBFORM,
  COPY_LAYOUT_FIELD_GROUPS,
  SET_RULES_MAPPING,
  SET_MAPPING_TAGS,
  CLEAR_FIELD_GROUPS,
  SET_EMAIL_CONFIG_LIST,
  ADD_INPROGRESS_STEP_EXECUTION,
  REMOVE_INPROGRESS_STEP_EXECUTION,  
  CLEAR_SUBFORM_FIELD_VALIDATION,
  SET_ONLOAD_DATA_CONFIG,
  SET_ONCHANGE_DATA_CONFIG,
  SET_ONCHANGE_DATA_VARIABLE_LIST,
  HANDLE_INPUT_BLUR,
  UPDATE_SECTION_SORT_BY,
  DETAILVIEW_SORT_BY_HANDLER,
  SET_CARRIER_SERVICES,
  UPDATE_LAYOUT_DATA,
  SET_FILE_ID,
  SET_ONCHANGE_DATA_CONFIG_QC,
  SET_ONCHANGE_DATA_VARIABLE_LIST_QC,
  DRAG_ITEM_IN_QUICKCREATE,
  SETWINDOWNAME,
  DRAG_ITEM_IN_MOBILEVIEW,
  DETAILVIEW_DRAG,
  DETAILVIEW_REMOVE,
  SELECTORUNSELECT,
  
} from "../actionTypes/formBuilderTypes";
// import { startAsyncValidation } from "redux-form";
// import http from "../../services/http";

const modObj = {
    LAYOUT:[],
    ADDFORM:[],
    QUICKFORM:[],
    DETAILVIEW:[]
}
const defaultActionButtons = {
  status:1000,
  layout_type:0,
  html_code:null,
  max_territories:0,
  actionComponents:{},
  buttons:{
    'CREATE_CLONE':[],
    'EDIT':[],
    'VIEW_PAGE':[],
    'UTILITY_MENU':[],
    'EACH_RECORD':[],
    'MASS_ACTION':[],
    'LIST':[]
  }
};

const initialState = {
  fieldGroups:{
    ...modObj
  },
  nonFieldGroups:{
    ...modObj
  },
  layoutObject:{
    ...modObj
  },
  validationForms:{
    ...modObj
  },
  layoutRules:{
    ...modObj
  },
  validationRules:{
    ...modObj
  },
  subformData: {
    ...modObj
  },
  subformValidation:{
      ...modObj
  },
  mappingTags:[],
  layoutCustomizeSetting:{
    view:'CREATE', //CREATE,QUICKCREATE,DETAILVIEW
    activeSection:0,
    editorVisible: false,
    editorState: {},
  },
  layoutFieldsCount:{
    unUsed:{},
    used:{}
  },
  master_detail_window_properties:[],
  emailConfigList:[],
  stautsIsExist:false,
  avatarIsExist:false,
  rulesMapping:[],
  selectedMultiLookup:{},
  actionButton:{
    default:defaultActionButtons
  },
  lookupDependency:{},
  inProgressStepExecution:{},
  onChangeDataConfig:[],
  onLoadDataConfig:{},
  onChangeDataConfigVariables:{},

  onChangeDataConfigQC:[],
  onChangeDataConfigVariablesQC:{},
  windowName:"",
   selectAll:false,
  
  //MYSHIP-HARDCODE
  carrierServices:{carrierList:[],servicesList:[]}
};
let fieldId =null;


const FormBuilderReducer = (state = initialState, action) => {

  let {fieldGroups,nonFieldGroups,layoutObject,layoutRules,subformValidation,validationRules,validationForms,layoutCustomizeSetting,subformData,layoutFieldsCount,rulesMapping,mappingTags,inProgressStepExecution} = state;
  let updateLayoutObjectState = null,updateFieldGroupsState = null,updateNonFieldGroupsState = null,updateLayoutCustomizeSettingState = null,updateLayoutFieldsCount = null;
  let updateValidationFormsState = null,updateValidationRulesState = null,updateLayoutRulesState = null,updateSubformDataState = null,totalSectionCount = 0 ,updatedSubformValidationState = null,existData={},updateActionButtonState=null;
  const {type,payload,modType} = action;
  let updateSelectedMultiLookup,subform_row,updatedItems,message,activeSection,sectionId,fieldIndex,section_index,itemIndex,sectionIndex,bool,isNonFieldGroups,actionType,item,dragIndex,hoverIndex,value;
  switch (type) {
    case SETWINDOWNAME:
      return {
        ...state,
        windowName:payload
      }
    case SELECTORUNSELECT:
      return {
        ...state,
        selectAll:payload
      }
    case LAYOUT_FIELD_COUNT:
      updateLayoutFieldsCount  = {
        ...layoutFieldsCount,
        [modType]:payload
      }
      // console.log('payload',payload);
      return{
        ...state,
        layoutFieldsCount:updateLayoutFieldsCount
      }
    case CLEAR_FIELD_GROUPS:
      // console.log('CLEARING FIELD GROUPS ');
      updateFieldGroupsState = {   
         ...fieldGroups,
        [modType] : []
      }        
      return {
        ...state,
        fieldGroups:{...updateFieldGroupsState}
      }
    case SET_EMAIL_CONFIG_LIST:
      const newEmailConfigList=payload;
    return{
      ...state,emailConfigList:newEmailConfigList
    }

    case SET_RULES_MAPPING:
      const {rulesMappingObj} = payload;
      // console.log('rulesMappingObj',rulesMappingObj);
    return{
      ...state,
      rulesMapping:rulesMappingObj
    }  
    case SET_LAYOUT_DATA:
      const {layoutObjectData,fieldGroupsData,nonFieldGroupsData} = payload;
      updateLayoutObjectState = {
        ...layoutObject,
        [modType]:layoutObjectData
      }
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:fieldGroupsData
      }
      updateNonFieldGroupsState = {
        ...nonFieldGroups,
        [modType]:nonFieldGroupsData
      }
      updateLayoutCustomizeSettingState = {
        ...layoutCustomizeSetting,
        activeSection:0,
        view:'CREATE'
      }
      return {
        ...state,
        layoutObject:{...updateLayoutObjectState},
        fieldGroups:{...updateFieldGroupsState},
        nonFieldGroups:{...updateNonFieldGroupsState},
        layoutCustomizeSetting:{...updateLayoutCustomizeSettingState},
        layoutFieldsCount:{
          ...layoutFieldsCount,
          'used':updateUsedAndUnusedFields(fieldGroupsData,layoutFieldsCount)
        }
      }
    case SET_LAYOUT_DATA_SUBFORM:
      const {layoutObjectData1,fieldGroupsData1,nonFieldGroupsData1} = payload;
      updateLayoutObjectState = {
        ...layoutObject,
        [modType]:layoutObjectData1
      }
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:fieldGroupsData1
      }
      updateNonFieldGroupsState = {
        ...nonFieldGroups,
        [modType]:nonFieldGroupsData1
      }
      updateLayoutCustomizeSettingState = {
        ...layoutCustomizeSetting,
        activeSection:0,
        view:'CREATE'
      }
      // updateSubformDataState = {
      //   ...subformData,
      //   [modType]:[...subFormData1]
      // }
      return {
        ...state,
        layoutObject:{...updateLayoutObjectState},
        fieldGroups:{...updateFieldGroupsState},
        nonFieldGroups:{...updateNonFieldGroupsState},
        layoutCustomizeSetting:{...updateLayoutCustomizeSettingState},
        // subformData:updateSubformDataState
      }
      case SET_VALIDATION_RULES:
        updateValidationRulesState = {
          ...validationRules,
          [modType]:payload
        }
        return {
          ...state,
          validationRules:{...updateValidationRulesState},
        } 
        case UPDATE_LAYOUT_DATA: {
          const { field_id, lookupData } = payload;   
          updateFieldGroupsState = fieldGroups[modType]?.map((group) => {
            const updatedData = isSet(group.data, []).map((itm) => {
              if (itm.id === field_id) {
                itm.selectedValue = lookupData;
              }
              return itm;
            });
            return { ...group, data: updatedData };
          }) || [];     
          return {
            ...state,
            fieldGroups: {
              ...fieldGroups,
              [modType]: updateFieldGroupsState
            }
          };
        }
    case SET_LAYOUT_RULES:
      updateLayoutRulesState = {
        ...layoutRules,
        [modType]:payload
      }
      return {
        ...state,
        layoutRules:{...updateLayoutRulesState},
      } 
    case LAYOUT_SETTINGS:
      const{type,settingObj} = payload;
      updateLayoutCustomizeSettingState = {
        ...layoutCustomizeSetting,
        [settingObj]:type
      }    
    return {
        ...state,
        layoutCustomizeSetting:{...updateLayoutCustomizeSettingState}
      };
    case SET_MAPPING_TAGS:
      const {tags} = payload;
      return{
        ...state,
        mappingTags:tags
      }  
    case ADD_SECTION_TO_PREVIEW:
      totalSectionCount = fieldGroups[modType].length;
      updateLayoutCustomizeSettingState = {
        ...layoutCustomizeSetting,
        activeSection:totalSectionCount,
      }
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[
          ...fieldGroups[modType],
          {
            type:"section",
            title:"HEADING "+totalSectionCount,
            column_type:"single",
            section_index:totalSectionCount,
            data:[]
          }
        ]
      }
    return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
        layoutCustomizeSetting:{...updateLayoutCustomizeSettingState}
      };
      case ADD_COPY_SECTION_TO_LAYOUT:
        totalSectionCount = fieldGroups[modType].length;
        // console.log('payload',payload);
        // updateLayoutCustomizeSettingState = {
        //   ...layoutCustomizeSetting,
        //   activeSection:totalSectionCount,
        // }
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...fieldGroups[modType],
            ...payload
          ]
        }
      return {
          ...state,
          fieldGroups:{...updateFieldGroupsState},
          // layoutCustomizeSetting:{...updateLayoutCustomizeSettingState}
        };
    case FIELD_PERMISSION_ONCHANGE:
      sectionIndex = payload.sectionIndex;
      fieldIndex = payload.fieldIndex;
      const permission =  payload.permission;
      const isChecked = payload.isChecked;
      let updateFieldPermissions = fieldGroups[modType][sectionIndex].data[fieldIndex];
      if(permission==='EDITABLE'){
        updateFieldPermissions.is_editable = (isChecked===true)?true:false;
      }else if(permission==='REMOVABLE'){
        updateFieldPermissions.is_removable = (isChecked===true)?true:false;
      }else if(permission==='ALL'){
        updateFieldPermissions.is_removable = (isChecked===true)?true:false;
        updateFieldPermissions.is_editable = (isChecked===true)?true:false;
      }
      fieldGroups[modType][sectionIndex].data[fieldIndex] = updateFieldPermissions;
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[
          ...fieldGroups[modType]
        ]
      }
      return {
        ...state,
        fieldGroups:{...updateFieldGroupsState}
      };
    case ADD_REMOVE_ITEM_TO_QUICK_CREATE: 
      fieldIndex = payload.fieldIndex;
      sectionIndex = payload.sectionIndex;
      bool = payload.bool;
      let quickData=[]

      fieldGroups[[modType]].forEach((section,sectionIndex) => { 
        section.data.forEach((field,fieldIndex)=>{
             quickData.push(field)

        })
      })
      const qclength=quickData.filter((item)=>item.quickCreate===true).slice().sort((a,b)=>a.qcItemIndex-b.qcItemIndex)  
      if(bool===true){
         quickData[fieldIndex].quickCreate = bool
        quickData[fieldIndex].qcItemIndex=qclength.length+1
      }else{
         qclength[fieldIndex].quickCreate = bool
        quickData[fieldIndex].qcItemIndex=0
      }
      // {fieldGroups.forEach((section,sectionIndex) => { 
      //   section.data.forEach((field,fieldIndex)=>{
      //     if(field.quickCreate===true || field.required===true){
            
      //     }
      //   })
      // })}
       updateFieldGroupsState = {
         ...fieldGroups,
         [modType]:[
           ...fieldGroups[modType]
         ]
       }
       return {
         ...state,
         fieldGroups:{...updateFieldGroupsState},
       };    
    case ADD_REMOVE_ITEM_TO_MOBILE_VIEW: 
       fieldIndex = payload.fieldIndex;
       sectionIndex = payload.sectionIndex;
       bool = payload.bool;
      //  fieldGroups[modType][sectionIndex].data[fieldIndex].is_mobile_view = bool
       let mobileviewdata=[]

       fieldGroups[[modType]].forEach((section,sectionIndex) => { 
         section.data.forEach((field,fieldIndex)=>{
           mobileviewdata.push(field)
 
         })
       })
       const mvlength=mobileviewdata.filter((item)=>item.is_mobile_view===true).slice().sort((a,b)=>a.mobileViewItemIndex-b.mobileViewItemIndex) 
           
       if(bool===true){
         mobileviewdata[fieldIndex].is_mobile_view=bool
         mobileviewdata[fieldIndex].mobileViewItemIndex=mvlength.length+1
       }else{
         mvlength[fieldIndex].is_mobile_view=bool
         mobileviewdata[fieldIndex].mobileViewItemIndex=0
       }      
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...fieldGroups[modType]
          ]
        }
        return {
          ...state,
          fieldGroups:{...updateFieldGroupsState},
        };    
     
    case ADD_FORM_TO_PREVIEW:
      totalSectionCount = fieldGroups[modType].length;
      updateLayoutCustomizeSettingState = {
        ...layoutCustomizeSetting,
        activeSection:totalSectionCount,
      }
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[
          ...fieldGroups[modType],
          {
            type:"subform",
            title:"HEADING "+totalSectionCount,
            column_type:"table",
            section_index:totalSectionCount,
            data:[],
            // sort_by:{},
          }
        ]
      }
    return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
      };
    case UPDATE_SECTION_HEAD:
        activeSection = layoutCustomizeSetting.activeSection;
        fieldGroups[modType][activeSection].title = payload.title;
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...fieldGroups[modType]
          ]
        }
      return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
      };
      case UPDATE_SECTION_SORT_BY:
        activeSection = layoutCustomizeSetting.activeSection;
        fieldGroups[modType][activeSection].sort_by = payload.sortBy;
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...fieldGroups[modType]
          ]
        }
      return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
      };
      case UPDATE_LAYOUT_ONCHANGE:
        updateLayoutObjectState = {
          ...layoutObject,
          [modType]:{
            ...layoutObject[modType],
            layout_name:payload.layoutName
          }
        }
        return {
            ...state,
            layoutObject:{...updateLayoutObjectState}
       };
      case REMOVE_SECTION:
        if(fieldGroups[modType].length>1){
          fieldGroups[modType].splice(payload.id, 1);
          activeSection = 0
        }
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...fieldGroups[modType].map((section,index)=>{
              section.section_index = index;
              return section;
            })
          ]
        }
        totalSectionCount = fieldGroups[modType].length;
        updateLayoutCustomizeSettingState = {
          ...layoutCustomizeSetting,
          activeSection:totalSectionCount,
        }
       return {
          ...state,
          fieldGroups:{...updateFieldGroupsState},
          layoutCustomizeSetting:{...updateLayoutCustomizeSettingState}
        };   
    
    case ADD_ITEM_TO_PREVIEW:
      item = payload.item;
      dragIndex = payload.dragIndex;
      hoverIndex = payload.hoverIndex;
      //Get Active section
      console.log('item',item);
      let isLimitReached = isUsedFieldsLimitReached(fieldGroups[modType],layoutFieldsCount,item.element);
      activeSection = layoutCustomizeSetting.activeSection;
      activeSection = (activeSection)?activeSection:0;
      let fieldGroupsSecData = fieldGroups[modType][activeSection].data;
      const itemDragIndex = fieldGroupsSecData.length;
      if(isLimitReached===false){
        fieldGroups[modType][activeSection].data = [...fieldGroupsSecData,item];
      }
      
      //DRAG and DROP
      if(dragIndex!==undefined && isLimitReached===false){
        const itemDragCardI = fieldGroups[modType][activeSection].data[itemDragIndex];
        fieldGroups[modType][activeSection].data = update(fieldGroupsSecData, {
          $splice: [[itemDragIndex, 1], [(hoverIndex), 0, itemDragCardI]]
        });
      }
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...fieldGroups[modType],
          ]
        }
        
      return {
        ...state,
        fieldGroupsState:{...updateFieldGroupsState},
        layoutCustomizeSetting:{
          ...layoutCustomizeSetting,
          editorVisible: (item.element!=='Blank' && isLimitReached===false)?true:false,
          editorState: {
            sectionType:fieldGroups[modType][activeSection].type,
            editItem: item,
            itemIndex: (hoverIndex!==undefined)?hoverIndex:itemDragIndex
          }
        },
        stautsIsExist :checkIsStatusFieldIsExists(updateFieldGroupsState[modType]),
        avatarIsExist :checkIsAvatarIsExists(updateFieldGroupsState[modType]),
        layoutFieldsCount:{
          ...layoutFieldsCount,
          'used':updateUsedAndUnusedFields(fieldGroups[modType],layoutFieldsCount)
        }
      };
    case DETAILVIEW_DRAG:      
      dragIndex = payload.dragIndex;
      hoverIndex = payload.hoverIndex;
      updateNonFieldGroupsState = {...nonFieldGroups};
      updateFieldGroupsState = {...fieldGroups};
      let DvToolbarItems = [];
      fieldGroups[modType].forEach((section) => {
        if(section.type!=='subform'){
            section.data.forEach((field,fieldIndex)=>{
              if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
               DvToolbarItems.push(field);
              }
            })
        }
      })
       nonFieldGroups[modType].forEach((section) => {
         if(section.type!=='subform'){
             section.data.map((field,fieldIndex)=>{
               if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
                DvToolbarItems.push(field);
               }
             })
         }
       })
       let detailData=DvToolbarItems.slice().sort((a,b)=>a.detailViewItemIndex-b.detailViewItemIndex)
       let [movedDVItem] = detailData.splice(dragIndex, 1);
       detailData.splice(hoverIndex, 0, movedDVItem);
       detailData.forEach((item, index) => {
         item.detailViewItemIndex = index;
       });
       updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[
          ...fieldGroups[modType]
        ]
      }
       return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
        nonFieldGroups:{...updateNonFieldGroupsState}
      };
      
    case DETAILVIEW_ADD:
      const {master_detail_windows} = payload;
      fieldIndex = payload.fieldIndex;
      sectionIndex = payload.sectionIndex;
      bool = payload.bool;
      isNonFieldGroups = payload.isNonFieldGroups;
      actionType = payload.actionType;
      updateLayoutObjectState = {...layoutObject};
      updateNonFieldGroupsState = {...nonFieldGroups};
      updateFieldGroupsState = {...fieldGroups};
      //master details windows object details
      if(actionType==='WindowDropDetailView'){
        updateLayoutObjectState = {
          ...layoutObject,
          [modType]:{
            ...layoutObject[modType],
            master_detail_windows:master_detail_windows
          }
        }
      }else{
        let DvToolbardata = [];
        fieldGroups[modType].forEach((section) => {
          if(section.type!=='subform'){
              section.data.forEach((field,fieldIndex)=>{
                if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
                  DvToolbardata.push(field);
                }
              })
          }
        })
         nonFieldGroups[modType].forEach((section) => {
           if(section.type!=='subform'){
               section.data.map((field,fieldIndex)=>{
                 if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
                  DvToolbardata.push(field);
                 }
               })
           }
         })
         let dvDatalength=DvToolbardata.length
        //Add or remove non fields data
        if(isNonFieldGroups===true){
          nonFieldGroups[modType][0].data[fieldIndex].is_present_in_detailview = bool;
          if(bool){
            nonFieldGroups[modType][0].data[fieldIndex].detailViewItemIndex=dvDatalength
          }else{
            nonFieldGroups[modType][0].data[fieldIndex].detailViewItemIndex=0
          }
          updateNonFieldGroupsState = {
            ...nonFieldGroups,
            [modType]:[
              ...nonFieldGroups[modType]
            ]
          }
        }else{
          //Add or remove fieldgroups data
          fieldGroups[modType][sectionIndex].data[fieldIndex].is_present_in_detailview = bool;
          if(bool){
            fieldGroups[modType][sectionIndex].data[fieldIndex].detailViewItemIndex=dvDatalength
          }else{
            fieldGroups[modType][sectionIndex].data[fieldIndex].detailViewItemIndex=0
          }
          updateFieldGroupsState = {
            ...fieldGroups,
            [modType]:[
              ...fieldGroups[modType]
            ]
          }
        }
      }
      return {
        ...state,
        layoutObject:{...updateLayoutObjectState},
        fieldGroups:{...updateFieldGroupsState},
        nonFieldGroups:{...updateNonFieldGroupsState}
      };
    case DETAILVIEW_REMOVE:
      itemIndex  = payload.itemIndex;
      let DVdataRemove = [];
      fieldGroups[modType].forEach((section) => {
        if(section.type!=='subform'){
            section.data.forEach((field,fieldIndex)=>{
              if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
                DVdataRemove.push(field);
              }
            })
        }
      })
       nonFieldGroups[modType].forEach((section) => {
         if(section.type!=='subform'){
             section.data.map((field,fieldIndex)=>{
               if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
                DVdataRemove.push(field);
               }
             })
         }
       })
       DVdataRemove.slice().sort((a,b)=>a.detailViewItemIndex-b.detailViewItemIndex)[itemIndex].is_present_in_detailview=false
       updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[
          ...fieldGroups[modType]
        ]
      }
      updateNonFieldGroupsState = {
        ...nonFieldGroups,
        [modType]:[
          ...nonFieldGroups[modType]
        ]
      }
    return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
        nonFieldGroups:{...updateNonFieldGroupsState}
      };  
    case DETAILVIEW_TYPE_HANDLER:
      isNonFieldGroups = payload.isNonFieldGroups;
      itemIndex  = payload.itemIndex;
      // sectionIndex = payload.sectionIndex;
      const tabType = payload.tabType;
      let DVdata = [];
      fieldGroups[modType].forEach((section) => {
        if(section.type!=='subform'){
            section.data.forEach((field,fieldIndex)=>{
              if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
                DVdata.push(field);
              }
            })
        }
      })
       nonFieldGroups[modType].forEach((section) => {
         if(section.type!=='subform'){
             section.data.map((field,fieldIndex)=>{
               if((field.element==='Lookup' || field.element==='MultiLookup') && field.is_present_in_detailview==true){
                DVdata.push(field);
               }
             })
         }
       })
      DVdata.slice().sort((a,b)=>a.detailViewItemIndex-b.detailViewItemIndex)[itemIndex].preview_type=tabType
      // if(isNonFieldGroups===true){
      //   nonFieldGroups[modType][0].data[itemIndex].preview_type = tabType;
      // }else{
      //   fieldGroups[modType].data[itemIndex].preview_type = tabType
      // }
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[
          ...fieldGroups[modType]
        ]
      }
      updateNonFieldGroupsState = {
        ...nonFieldGroups,
        [modType]:[
          ...nonFieldGroups[modType]
        ]
      }
      return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
        nonFieldGroups:{...updateNonFieldGroupsState}
      };  
      case DETAILVIEW_SORT_BY_HANDLER:
        sectionIndex = payload.sectionIndex;
        const sortBy = payload.sortBy;
       
          fieldGroups[modType][sectionIndex].sort_by = sortBy
        
        updateFieldGroupsState = {
          ...fieldGroups,
         [modType]:[
            ...fieldGroups[modType]
          ]
        }
        updateNonFieldGroupsState = {
          ...nonFieldGroups,
          [modType]:[
            ...nonFieldGroups[modType]
          ]
        }
        return {
          ...state,
          fieldGroups:{...updateFieldGroupsState},
          nonFieldGroups:{...updateNonFieldGroupsState}
        }; 
    case UPDATE_FORM_FIELD_VALIDATION:
      fieldId = payload.fieldId;
      message = payload.message;
      updateValidationFormsState = {
        ...validationForms,
        [modType]:{
          ...validationForms[modType],
          [fieldId]:message
        }
      };
        return{
          ...state,
          fieldGroups:{...fieldGroups},
          validationForms:{...updateValidationFormsState}
        }   
    case CLEAR_FORM_FIELD_VALIDATION:
      updateValidationFormsState = {...validationForms};
      updateValidationFormsState[modType] = [];
      updatedSubformValidationState={...subformValidation}
      updatedSubformValidationState[modType]=[];
        return{
          ...state,
          validationForms: {...updateValidationFormsState},
          subformValidation : {...updatedSubformValidationState}
    }
    
    case UPDATE_SUBFORM_FIELD_VALIDATION:
      // console.log("UPDATE_SUBFORM_FIELD_VALIDATION",payload);
      fieldId = payload.fieldId;   
      subform_row = payload.subform_row;
      message = payload.message;
      updatedSubformValidationState = {
        ...subformValidation,
        [modType]:{
          ...subformValidation[modType],
          [fieldId]:{...subformValidation[modType][fieldId],
           message:message,
           [subform_row] :message,           
          } 
         }   
      };
      // console.log("updatedSubformValidationState",updatedSubformValidationState);
      return {
        ...state,
        subformValidation : {...updatedSubformValidationState}
      }
    case CLEAR_SUBFORM_FIELD_VALIDATION :
      subform_row = payload.subform_row;
      if(subform_row===undefined){
        updatedSubformValidationState = {...subformValidation,[modType]:[]}
      }else{
        let upd = {};
        Object.entries(subformValidation[modType]).forEach(([key, value]) => {
          let upd1 = {};
          Object.entries(value).forEach(([key1, message]) => {
            if (key1 !== String(subform_row) && key1 !== "message" && parseInt(key1) > subform_row) {
              upd1 = { ...upd1, [parseInt(key1) - 1]: message };
            } else if (key1 !== String(subform_row) && key1 !== "message") {
              upd1 = { ...upd1, [parseInt(key1)]: message };
            }
          });
          upd = { ...upd, [key]: upd1 };
        });
        updatedSubformValidationState = {...subformValidation,[modType]:{...upd}}
      }
      return {
        ...state ,
        subformValidation : {...updatedSubformValidationState}
      } 
    case REMOVE_ITEM_FROM_PREVIEW:
      fieldIndex = payload.fieldIndex;
      sectionIndex = payload.sectionIndex;
      activeSection = layoutCustomizeSetting.activeSection;
      updateFieldGroupsState = fieldGroups;
      updateFieldGroupsState[modType][sectionIndex].data = updateFieldGroupsState[modType][sectionIndex].data.filter((item, index) => index !== fieldIndex);
      return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
        layoutFieldsCount:{
          ...layoutFieldsCount,
          'used':updateUsedAndUnusedFields(updateFieldGroupsState[modType],layoutFieldsCount)
        }
      };
    case DRAG_ITEM_IN_PREVIEW:
      sectionId = payload.sectionId;
      dragIndex = payload.dragIndex;
      hoverIndex = payload.hoverIndex;
      activeSection = layoutCustomizeSetting.activeSection;
      let updateMovingData = {...fieldGroups};
        if(activeSection===sectionId){
          const dragCard = updateMovingData[modType][activeSection].data[dragIndex];
          updatedItems = update(updateMovingData[modType][activeSection].data, {
            $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
          });
          updateMovingData[modType][activeSection].data = updatedItems;
        }else{
          let movingItem = updateMovingData[modType][sectionId].data[dragIndex];
          updateMovingData[modType][sectionId].data = updateMovingData[modType][sectionId].data.filter((item, index) => index !== dragIndex);
          updateMovingData[modType][activeSection].data = [...updateMovingData[modType][activeSection].data,movingItem];
        }
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...updateMovingData[modType]
          ]
        }
    return {
      ...state,
      fieldGroups: {...updateFieldGroupsState}
    };  
    case DRAG_ITEM_IN_QUICKCREATE:     
      sectionId = payload.sectionId;
      dragIndex = payload.dragIndex;
      hoverIndex = payload.hoverIndex;
      activeSection = layoutCustomizeSetting.activeSection;
      let MovingData = {...fieldGroups};
      let quick=[]
      // console.log("fied",fieldGroups);
      fieldGroups[[modType]].forEach((section,sectionIndex) => { 
        section.data.forEach((field,fieldIndex)=>{
          // if(field.quickCreate===true || field.required===true){
             quick.push(field)
          // }
        })
      })
        
          let quickDataArr=quick.filter((item)=>item.quickCreate===true).slice().sort((a,b)=>a.qcItemIndex-b.qcItemIndex)
          let [movedItem] = quickDataArr.splice(dragIndex, 1);
          quickDataArr.splice(hoverIndex, 0, movedItem);
          quickDataArr.forEach((item, index) => {
            item.qcItemIndex = index;
          });
        // }
        // else{
        //   let quickdata = MovingData[modType][sectionId].data.filter((item)=>item.quickCreate===true).slice().sort((a,b)=>a.qcItemIndex-b.qcItemIndex);
        //   quickdata[dragIndex].qcItemIndex= MovingData[modType][activeSection].data.length
        //   let movingItem=quickdata[dragIndex]
        //   MovingData[modType][sectionId].data = MovingData[modType][sectionId].data.filter((item, index) => movingItem.id !== item.id);
        //   MovingData[modType][activeSection].data = [...MovingData[modType][activeSection].data,movingItem];      
        // }
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...MovingData[modType]
          ]
        }
    return {
      ...state,
      fieldGroups: {...updateFieldGroupsState}
    };  
    case DRAG_ITEM_IN_MOBILEVIEW: 
    sectionId = payload.sectionId;
    dragIndex = payload.dragIndex;
    hoverIndex = payload.hoverIndex;
    activeSection = layoutCustomizeSetting.activeSection;
    let fields = {...fieldGroups};
    let mobiledata=[]
    // console.log("fied",fieldGroups);
    fieldGroups[[modType]].forEach((section,sectionIndex) => { 
      section.data.forEach((field,fieldIndex)=>{
        // if(field.quickCreate===true || field.required===true){
          mobiledata.push(field)
        // }
      })
    })

        let mobilekDataArr=mobiledata.filter((item)=>item.is_mobile_view===true).slice().sort((a,b)=>a.mobileViewItemIndex-b.mobileViewItemIndex)
        let [movedmvItem] = mobilekDataArr.splice(dragIndex, 1);
        mobilekDataArr.splice(hoverIndex, 0, movedmvItem);
        mobilekDataArr.forEach((item, index) => {
          item.mobileViewItemIndex = index;
        });
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
            ...fields[modType]
          ]
        }
        return {
          ...state,
          fieldGroups: {...updateFieldGroupsState}
        }; 
    case DRAG_CONTENT_IN_PREVIEW:
      const { dragContentIndex, hoverContentIndex} = payload;
      const dragCardContent = fieldGroups[modType][dragContentIndex];
      let updatedContent = update(fieldGroups[modType], {
        $splice: [[dragContentIndex, 1], [hoverContentIndex, 0, dragCardContent]]
      });
      updatedContent = updatedContent.map((section,index)=>{
        section.section_index = index;
        return section;
      });
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[...updatedContent]
      }
        return {
          ...state,
          fieldGroups: {...updateFieldGroupsState}
        };  
    
    case LAYOUT_COLUMN_CHANGE:
      section_index = payload.section_index;
      const {column_type} = payload;
      fieldGroups[modType][section_index].column_type = column_type;
      return {
        ...state,
        fieldGroups:{...fieldGroups}
      }; 
      case DROPDOWN_FIELD_MAPPING:
       const mappingObj = payload.mappingObj;
       const dependencyMap = payload.dependencyMap;
        updateFieldGroupsState = {...fieldGroups};
        updateSubformDataState = subformData[modType];Object.entries(dependencyMap).forEach(([fieldId, dependency]) => {
              let selectedOptionInMapping = 0;
              const fieldIndex = updateSubformDataState[mappingObj.subFormIndex].subform_rows[mappingObj.rowIndex].subform_column_values.findIndex((i=>i.table_descriptor_id===fieldId));
              if(mappingObj.formType==="SUBFORM"){
                let subformField = updateSubformDataState[mappingObj.subFormIndex].subform_rows[mappingObj.rowIndex].subform_column_values[mappingObj.columnIndex];
                let sectionField = updateFieldGroupsState[modType][mappingObj.section_index].data[mappingObj.itemIndex];
                let updatedOptions = [];
                let unFilterOption = isSet(sectionField.unFilterOption,subformField.unFilterOption)?isSet(sectionField.unFilterOption,subformField.unFilterOption):isSet(sectionField.options,subformField.options);
                    if(mappingObj.dependencyNull){
                      updatedOptions = []
                    }else{
                      updatedOptions = dependency.map((option)=>{
                        option.id = (option.id)?option.id:option.key;
                        if(subformField.selectedValue===option.id){
                          selectedOptionInMapping++;
                        }
                        return option;
                      });
                    }
                    updatedOptions.push({
                      id:'',
                      value:'-None-'
                    });
                    // console.log('updatedOptions',updatedOptions);
                    updateSubformDataState[mappingObj.subFormIndex].subform_rows[mappingObj.rowIndex].subform_column_values[fieldIndex]['options'] = updatedOptions;
                    updateSubformDataState[mappingObj.subFormIndex].subform_rows[mappingObj.rowIndex].subform_column_values[fieldIndex]['unFilterOption'] = unFilterOption;
                    if(selectedOptionInMapping===0){
                      updateSubformDataState[mappingObj.subFormIndex].subform_rows[mappingObj.rowIndex].subform_column_values[fieldIndex].selectedValue = '';
                    }

              }else{
                updateFieldGroupsState[modType][mappingObj.section_index].data.map((field)=>{
                  if(field.id===fieldId){
                    field.unFilterOption = (field.unFilterOption)?field.unFilterOption:field.options;
                    if(mappingObj.dependencyNull){
                      field.options = []
                    }else{
                      field.options = dependency.map((option)=>{
                        option.id = (option.id)?option.id:option.key;
                        if(field.selectedValue===option.id){
                          selectedOptionInMapping++;
                        }
                        return option;
                      });
                    }
                    field.options.push({
                      id:'',
                      value:'-None-'
                    })
                    if(selectedOptionInMapping===0)
                      field.selectedValue = '';
                  }
                  return field;
                });
              }
             
            
            
          })
        
          updateSubformDataState = {
            ...subformData,
            [modType]:[...updateSubformDataState]
          }
      return {
        ...state,
        fieldGroups:{...updateFieldGroupsState},
        subformData:{...updateSubformDataState}
      }
     case HANDLE_INPUT_BLUR:
      const payloadFieldObj = payload.fieldObj;
      updateActionButtonState = state.actionButton;
      updateFieldGroupsState = [...fieldGroups[modType]];
      updateSubformDataState = subformData[modType];
      if (payloadFieldObj.isBulk) {
        isSet(payloadFieldObj.valuesInArr, []).forEach((itm) => {
            const { key: payloadObj, value: itemValue } = itm;
            if (isSet(payloadObj.isExist,true)===true && payloadObj.type === 'SECTION' && payloadObj.section.type === 'subform') {
                updateFieldGroupsState[payloadObj.sectionIndex]['subform_rows'] = itemValue;
                updateSubformDataState = [...itemValue];
            } else if(isSet(payloadObj.isExist,true)===true) {
              updateFieldGroupsState[payloadObj.sectionIndex].data[payloadObj.fieldIndex].selectedValue = itemValue;
            }
        });
    } else {
        const { type, section, sectionIndex, fieldIndex } = payloadFieldObj;
        if (type === 'SECTION' && section.type === 'subform') {
            updateFieldGroupsState[sectionIndex]['subform_rows'] = payload.value;
            updateSubformDataState = [...payload.value];
        } else {
            updateFieldGroupsState[sectionIndex].data[fieldIndex].selectedValue = payload.value;
        }
    }
      if(layoutRules[modType]!==undefined){
        const {updateFieldGroups, updateSubFormData,updateActionButton} =  layoutRulesValidation(
          layoutRules[modType],
          {
            fieldGroups:updateFieldGroupsState,
            subformData:updateSubformDataState,
            mappingTags:mappingTags,
            actionButton:state.actionButton,
            modType:modType
          },
          rulesMapping,layoutObject[modType],validationForms[modType]);
          updateFieldGroupsState = updateFieldGroups;
          updateSubformDataState = updateSubFormData;
          updateActionButtonState = updateActionButton;
      }
      // console.log('updateSubformDataState',updateSubformDataState);
      updateSubformDataState = {
        ...subformData,
        [modType]:[...updateSubformDataState]
      }
      // console.log('updateFieldGroupsState',updateFieldGroupsState);
      
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[...updateFieldGroupsState]
      }
      return{
        ...state,
        actionButton:updateActionButtonState,
        fieldGroups:{...updateFieldGroupsState},
        subformData:{...updateSubformDataState}
      }
     case HANDLE_INPUT_CHANGE:
      const {inputType,fieldObj} = payload;
      value = payload.value;
      // console.log('payload',payload);
      updateActionButtonState = state.actionButton;
      updateFieldGroupsState = [...fieldGroups[modType]];
      updateSubformDataState = subformData[modType];
      let isFieldGrpIsExistCount = 0;
      let clearValidationsArr = [];
      updateFieldGroupsState.forEach((grp)=>{
        if(isSet(grp.data,[]).length>0){
          isFieldGrpIsExistCount++
        }
      });
      if(isFieldGrpIsExistCount>0){
        if(updateFieldGroupsState[fieldObj.section_index].type==="subform"){
          //IF SUBFORM
          let elementOriginal = isSet(fieldObj.item.element_original,"");
          if(inputType==='Lookup' || elementOriginal === "Lookup"){
            let tabescriptorList = [];
            updateFieldGroupsState.forEach((section)=>{
              isSet(section.data,[]).forEach((item)=>{
                // console.log("data",item);
                tabescriptorList.push(item);
              });
            });
            const lookupMappingDataa = setLookupMappingFieldValue(updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values,fieldObj,state.lookupDependency,"subform",tabescriptorList);
            clearValidationsArr = lookupMappingDataa.clearValidations;
            
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values = lookupMappingDataa.updatedPreviewItems;
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].selected_value = isSet(value.selectedValue,value);
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].overridden = true;
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].dpnm = fieldObj?.label ?? "";
          }
          else if(inputType==='Files'){
            // updateSubformDataState = setLookupMappingFieldValue(updateFieldGroupsState,fieldObj,state.lookupDependency);
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].files = value;
          }
          else if(inputType==="Reminder"){
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].reminder = value;
          }else if(inputType==='currencyType'){
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].currency_code = isSet(value.selectedValue,value);
          }
          // else if(inputType==='date'){
          //   updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].selected_value = value;
          // }
          else{
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].selected_value = value;
            updateSubformDataState[fieldObj.subFormIndex].subform_rows[fieldObj.rowIndex].subform_column_values[fieldObj.columnIndex].overridden = true;

          }
          
          // console.log('updateSubformDataState',updateSubformDataState);
        }else{
          // IF SECTION 
          if(inputType==='currencyType'){
            updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex].currency_code = value;
          }else if(inputType==='exchangeRate'){
            updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex].exchange_rate = value;
          }else if(inputType==='Reminder'){
              updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex].reminder = value;
          }else if(inputType==='reload'){
            // updateFieldGroupsState = updateFieldGroupsState;
          }
          // else if(inputType==='date'){ 
          //   updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex] = {
          //     ...updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex],
          //   //  ['system_datetime_format']: (value.systemFormat==='Invalid date')?'':value.systemFormat,
          //    ['selectedValue']:value,
          //   }
          // }
          else if(inputType==='Files'){
              updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex].files = value;
          }else if(inputType==='Lookup' || inputType==='MultiLookup'){
            // console.log('value.ruleMapping',value.ruleMapping);
              updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex]={
                ...updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex],
                'selectedValue':value.selectedValue,
                'displayValue':value.displayValue,
                'ruleMapping':value.ruleMapping,
                'stateValue':value.stateValue,
                'required_query':isSet(value.required_query,false),
                'related_window_fields':(isSet(fieldObj.item.has_related_window,false)===true)?
                isSet(value.related_window_fields,[]):null
              }
              if(inputType==='Lookup'){
                const lookupMappingData = setLookupMappingFieldValue(updateFieldGroupsState,fieldObj,state.lookupDependency,"section");
                clearValidationsArr = lookupMappingData.clearValidations;
                updateFieldGroupsState = lookupMappingData.updatedPreviewItems;
              }
          }else{
              updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex].selectedValue = value;
          }
        }
        updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex] = {
          ...updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex],
          'overridden':true
        }
        // updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex]['overridden'] = true;
        //clearValidationsArr
        const selectedFieldId = updateFieldGroupsState[fieldObj.section_index].data[fieldObj.itemIndex].id;
        validationForms[modType][selectedFieldId] = '';
        if(isSet(subformValidation[modType][selectedFieldId],null)!==null){
          if(isSet(subformValidation[modType][selectedFieldId][fieldObj.rowIndex],null)!==null){
            subformValidation[modType][selectedFieldId][fieldObj.rowIndex]='';
          }
        }
        if(clearValidationsArr.length>0){
          clearValidationsArr.forEach((validationId)=>{
            validationForms[modType][validationId] = '';
           
            if(isSet(subformValidation[modType][validationId],null)!==null){
              if(isSet(subformValidation[modType][validationId][fieldObj.rowIndex],null)!==null){
                subformValidation[modType][validationId][fieldObj.rowIndex]='';
              }
            }
          })
        }
        if(layoutRules[modType]!==undefined){
          const {updateFieldGroups, updateSubFormData,updateActionButton} =  layoutRulesValidation(
            layoutRules[modType],
            {
              fieldGroups:updateFieldGroupsState,
              subformData:updateSubformDataState,
              mappingTags:mappingTags,
              actionButton:state.actionButton,
              modType:modType
            },
            rulesMapping,layoutObject[modType],validationForms[modType]);
            // console.log('updateActionButton',updateActionButton);
            updateFieldGroupsState = updateFieldGroups;
            updateActionButtonState = updateActionButton;
            updateSubformDataState = updateSubFormData;
        }
      }
      //Hardcoded for myship
      if(fieldObj.item.api_custom_field_name==="cf_package_/_pallet" && value===getHardCodedIds('envelopeId')){
        updateSubformDataState = updateSubformDataState.filter(itm => {
          if (itm.field_group_name === "Package") {
            itm.subform_rows = itm.subform_rows.filter((i, iindex) => iindex === 0);
          }
          return true;
        });        
      }
      // 
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[...updateFieldGroupsState]
      }
      updateSubformDataState = {
        ...subformData,
        [modType]:[...updateSubformDataState]
      }
    return {
      ...state,
      actionButton:updateActionButtonState,
      fieldGroups:{...updateFieldGroupsState},
      validationForms:{...validationForms},
      subformData:{...updateSubformDataState},
      subformValidation:{...subformValidation},
    }
    case UPDATE_DETAIL_VIEW_STATUS:
      const {statusObj} = payload;
      value = payload.value;
      updateFieldGroupsState = [...fieldGroups[modType]];
      updateFieldGroupsState[statusObj.section_index].data[statusObj.itemIndex].selectedValue = value;
      updateFieldGroupsState = {
        ...fieldGroups,
        [modType]:[...updateFieldGroupsState]
      }
      return{
        ...state,
        fieldGroups:{...updateFieldGroupsState},
      }
    case ADD_SELECTED_MULTILOOKUP:
    //  action.payload.mLookupFieldId
    // const {mLookupFieldId} = payload;
      updateSelectedMultiLookup = { ...state.selectedMultiLookup}
      if(isSet(updateSelectedMultiLookup[payload.mLookupFieldId],null)===null){
        updateSelectedMultiLookup = {
          ...updateSelectedMultiLookup,
          [payload.mLookupFieldId]:[]
        }
      }
      let updatingMultiLookupArrays = [
        ...updateSelectedMultiLookup[payload.mLookupFieldId],
        payload.selectedRows
      ].reduce((acc, current) => {
        const x = acc.find(item => item.rowId === current.rowId);
        if (!x) {
          acc.push(current);
        }
        return acc;
      }, []);

      // console.log('payload.selectedRows',updatingMultiLookupArrays);
      updateSelectedMultiLookup = {
        ...updateSelectedMultiLookup,
        [payload.mLookupFieldId]:updatingMultiLookupArrays
        // [
        //   ...updateSelectedMultiLookup[payload.mLookupFieldId],
        //   payload.selectedRows
        // ]
      };
      
      // updateSelectedMultiLookup.push(action.payload.selectedRows);
      return {
        ...state,
        selectedMultiLookup:{...updateSelectedMultiLookup}
      }
    case SELECTORUNSELECT:
      let boolVal=payload
      updateSelectedMultiLookup = { ...state.selectedMultiLookup}      
        return {
          ...state,
          selectAll:payload
        }
    case REMOVE_SELECTED_MULTILOOKUP:
      updateSelectedMultiLookup = {...state.selectedMultiLookup};
      updateSelectedMultiLookup = {
        ...updateSelectedMultiLookup,
        [payload.mLookupFieldId]: updateSelectedMultiLookup[payload.mLookupFieldId].filter(item => item.rowId !== action.payload.selectedRowsId)
        // [payload.mLookupFieldId]:updateSelectedMultiLookup[payload.mLookupFieldId].filter((item,index)=>{
        //   if(item.rowId!== action.payload.selectedRowsId){
        //     return item;
        //   }
        // })
      };
      return {
          ...state,
          selectedMultiLookup:{...updateSelectedMultiLookup}
      }
    case CLEAR_SELECTED_MULTILOOKUP:
      updateSelectedMultiLookup = {...state.selectedMultiLookup};
      if(isSet(updateSelectedMultiLookup[payload.mLookupFieldId],null)===null){
        updateSelectedMultiLookup = {
          ...updateSelectedMultiLookup,
          [payload.mLookupFieldId]:[]
        }
      }
      /*updateSelectedMultiLookup = {
        ...updateSelectedMultiLookup,
        [payload.mLookupFieldId]:[]
      }*/
      updateSelectedMultiLookup = {};
      // console.log("updateSelectedMultiLookup",updateSelectedMultiLookup)
      return {
        ...state,
        selectedMultiLookup:{...updateSelectedMultiLookup}
      }
    case SET_SELECTED_MULTILOOKUP:
      const {selectedArr} = payload;
      updateSelectedMultiLookup = {...state.selectedMultiLookup};
      if(isSet(updateSelectedMultiLookup[payload.mLookupFieldId],null)===null){
        updateSelectedMultiLookup = {
          ...updateSelectedMultiLookup,
          [payload.mLookupFieldId]:[]
        }
      }
      updateSelectedMultiLookup = {
        ...updateSelectedMultiLookup,
        [payload.mLookupFieldId]:selectedArr
      }
      return{
        ...state,
        selectedMultiLookup:{...updateSelectedMultiLookup}
      } 
    case MASTER_WINDOW_LIST_ACTION:
       const{masterDetailData} = payload;
      return {
        ...state,
        master_detail_window_properties:[...masterDetailData]
      }     
    
    case UPDATE_ACTION_BUTTON:
      // console.log('payload',payload);
      const windowId = payload.windowId;

     return {
         ...state,
         actionButton:{
          ...state.actionButton,
          [windowId]:{...payload}
          
        }
    } 
    case SET_SUBFORM_DATA:
      updateSubformDataState = {
        ...subformData,
        [modType]:[...payload]
        //...subformData[modType],
      }
      return {
           ...state,
           subformData:{...updateSubformDataState}
      } 
    case UPDATE_SUBFORM_DATA:
      // console.log('payload',payload,modType,action);
      const subFormIndex = isSet(subformData[modType], []).findIndex(
        i => i.field_group_section_id === payload.field_group_section_id && 
             isSet(i.isViewMore, false) === isSet(payload.isViewMore, false)
      );
      
      let updatePayloadSubform = [...isSet(subformData[modType], [])]; 
      
      if (subFormIndex !== -1) {
        const updatedSubform = {
          ...updatePayloadSubform[subFormIndex],
          subform_rows: payload.subform_rows 
        };
        updatePayloadSubform[subFormIndex] = updatedSubform; 
      } else {
        updatePayloadSubform = [
          ...updatePayloadSubform, 
          payload 
        ];
      }
      
       updateSubformDataState = {
        ...subformData,
        [modType]: updatePayloadSubform // Update the specific modType with the new array
      };
      return {
        ...state,
        subformData:{...updateSubformDataState}
      }
    case SET_LOOKUP_DEPENDENCY:
      return{
        ...state,
        lookupDependency:{...payload}
      }
    case SHOW_EDITOR:
      activeSection = layoutCustomizeSetting.activeSection;
        return {
          ...state,
          layoutCustomizeSetting:{
            ...layoutCustomizeSetting,
            editorVisible: true,
            stautsIsExist :checkIsStatusFieldIsExists(fieldGroups[modType]),
            editorState: {
              sectionType:fieldGroups[modType][activeSection].type,
              editItem: payload.item,
              itemIndex: payload.index
            }
          }
        };
    case HIDE_EDITOR:
        return {
          ...state,
          layoutCustomizeSetting:{
            ...layoutCustomizeSetting,
            editorVisible: false,
            editorState: {}
          }
        };  
    case SUBMIT_EDITOR_STATE:
        const {editState} = payload;
        activeSection = layoutCustomizeSetting.activeSection;
        let updatedFromEditor = fieldGroups[modType][activeSection].data.map((item,index)=> {
          if (index === editState.itemIndex) {
            item = { ...editState };
              return item;
            }
            return item;
        });
        fieldGroups[modType][activeSection].data = updatedFromEditor;
        updateFieldGroupsState = {
          ...fieldGroups,
          [modType]:[
           ...fieldGroups[modType]
          ]
        }
      return { 
        ...state,
        fieldGroups:{...updateFieldGroupsState},
        layoutCustomizeSetting:{
          ...layoutCustomizeSetting,
          editorState:{},
          editorVisible:false
        }
      };
    case COPY_LAYOUT_FIELD_GROUPS:
      const {copyFieldGroupsData} = payload;
      var newArray = [];
      newArray.push.apply(newArray, fieldGroups.LAYOUT);
      newArray.push.apply(newArray, copyFieldGroupsData);
      updateFieldGroupsState = {
        ...fieldGroups,
        'LAYOUT':newArray
      }
      return{
        ...state,
        fieldGroups:{...updateFieldGroupsState},
      }
    case ADD_INPROGRESS_STEP_EXECUTION:
      const {data,jobId} = payload;
      // console.log(data,jobId);
      existData = inProgressStepExecution;
      existData[jobId]=data;
      return{
        ...state,
        inProgressStepExecution:existData
      };
    case REMOVE_INPROGRESS_STEP_EXECUTION:
      existData = inProgressStepExecution;
      if(Array.isArray(payload)) {
        payload.forEach(item => {
          delete existData[item];
        });
      }else {
        delete existData[payload];
      }
      return{
        ...state,
        inProgressStepExecution:existData
      };     
      case SET_ONCHANGE_DATA_CONFIG:
        return{
          ...state,
          onChangeDataConfig:payload
        };
      case SET_ONCHANGE_DATA_VARIABLE_LIST:
        
          return{
            ...state,
            onChangeDataConfigVariables:{
              ...state.onChangeDataConfigVariables,
              [payload.configId]:isSet(payload.data,[])
            }
          };
      case SET_ONCHANGE_DATA_CONFIG_QC:
            return{
              ...state,
              onChangeDataConfigQC:payload
            };
      case SET_ONCHANGE_DATA_VARIABLE_LIST_QC:
            
              return{
                ...state,
                onChangeDataConfigVariablesQC:{
                  ...state.onChangeDataConfigVariablesQC,
                  [payload.configId]:isSet(payload.data,[])
                }
              };
      case SET_ONLOAD_DATA_CONFIG:
        return{
          ...state,
          onLoadDataConfig:payload
        };  
      //MYSHIP-HARDCODE
      case SET_CARRIER_SERVICES:
        // console.log('payload',payload);
        return{
          ...state,
          carrierServices:payload
        }      
      case SET_FILE_ID:
        return{
          ...state,
          fileId:payload
        }
    default:
      return state;
  }
};

export default FormBuilderReducer 